import React, { useMemo, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import styles from '@/styles/components/chat/ThinkingPanel.module.css';

export interface ThinkingPanelProps {
  blocks: string[];
  isStreaming?: boolean;
  /**
   * Optional custom renderer for the thinking text.
   * If omitted, we render markdown (GFM) in a muted style.
   */
  renderBlock?: (text: string, idx: number) => React.ReactNode;
}

export const ThinkingPanel: React.FC<ThinkingPanelProps> = ({
  blocks,
  isStreaming,
  renderBlock,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const cleaned = useMemo(() => {
    return (blocks || [])
      .map(b => (b ?? '').toString())
      .map(b => b.trim())
      .filter(Boolean);
  }, [blocks]);

  if (cleaned.length === 0) return null;

  return (
    <details
      className={styles.details}
      open={isOpen}
      onToggle={e => setIsOpen((e.target as HTMLDetailsElement).open)}
    >
      <summary className={styles.summary}>
        <span className={styles.summaryLeft}>
          <span className={styles.label}>Thinking</span>
          <span className={styles.meta}>
            {cleaned.length} {cleaned.length === 1 ? 'block' : 'blocks'}
            {isStreaming ? ' · streaming' : ''}
          </span>
        </span>
        <span className={styles.chevron} aria-hidden="true" />
      </summary>

      <div className={styles.content}>
        {cleaned.map((text, idx) => (
          <div key={idx} className={styles.block}>
            {renderBlock ? (
              renderBlock(text, idx)
            ) : (
              <ReactMarkdown remarkPlugins={[remarkGfm]}>{text}</ReactMarkdown>
            )}
          </div>
        ))}
      </div>
    </details>
  );
};


